import React, { useEffect, useState } from 'react';
import { getCategories } from '../Data';
import { Global } from '../Variables/Global';
import { Link } from 'react-router-dom';
import './Category.css';

const CategoryAR = ({ onCategoryClick }) => {
    const [categories, setCategories] = useState([]);

    useEffect(() => {
        getCategories().then(res => setCategories(res));
    }, []);

    return (
        <div className="category-sidebar category-ar" dir="rtl">
            <h4 className="sidebar-title">الفئات</h4>

            <div className="category-grid">
                {categories.slice(0, 12).map((cat) => (
                    <Link
                        key={cat.CategoryId}
                        to={`/AR/Category/${cat.CategoryName}/${cat.CategoryId}`}
                        className="category-card"
                        onClick={() => onCategoryClick?.()}
                    >
                        <img
                            src={Global.PHOTO_URL + cat.MenuImage}
                            alt={cat.CategoryName}
                        />
                        <span>{cat.ArCategoryName}</span>
                    </Link>
                ))}
            </div>
        </div>
    );
};

export default CategoryAR;
